/*
 * Copyright (c) 2021.  Sanish Manandhar
 * All Rights Reserved
 */
export const COUPONS_CLEAN_REQUEST = 'COUPONS_CLEAN_REQUEST';
export const DISCOUNT_CODE_CLEAN_REQUEST = 'DISCOUNT_CODE_CLEAN_REQUEST';
export const SINGLE_COUPON_CLEAN_REQUEST = 'SINGLE_COUPON_CLEAN_REQUEST';

export const COUPONS_LIST_FETCH_REQUEST = 'COUPONS_LIST_FETCH_REQUEST';
export const COUPONS_LIST_FETCH_REQUEST_SUCCESS = 'COUPONS_LIST_FETCH_REQUEST_SUCCESS';
export const COUPONS_LIST_FETCH_REQUEST_FAILURE = 'COUPONS_LIST_FETCH_REQUEST_FAILURE';

export const GENERATE_DISCOUNT_CODE_REQUEST = 'GENERATE_DISCOUNT_CODE_REQUEST';
export const GENERATE_DISCOUNT_CODE_REQUEST_SUCCESS = 'GENERATE_DISCOUNT_CODE_REQUEST_SUCCESS';
export const GENERATE_DISCOUNT_CODE_REQUEST_FAILURE = 'GENERATE_DISCOUNT_CODE_REQUEST_FAILURE';

export const DISCOUNT_TYPE_FETCH_REQUEST = 'DISCOUNT_TYPE_FETCH_REQUEST';
export const DISCOUNT_TYPE_FETCH_REQUEST_SUCCESS = 'DISCOUNT_TYPE_FETCH_REQUEST_SUCCESS';
export const DISCOUNT_TYPE_FETCH_REQUEST_FAILURE = 'DISCOUNT_TYPE_FETCH_REQUEST_FAILURE';

export const COUPON_UPSERT_REQUEST = 'COUPON_UPSERT_REQUEST';
export const COUPON_UPSERT_REQUEST_SUCCESS = 'COUPON_UPSERT_REQUEST_SUCCESS';
export const COUPON_UPSERT_REQUEST_FAILURE = 'COUPON_UPSERT_REQUEST_FAILURE';

export const SINGLE_COUPON_FETCH_REQUEST = 'SINGLE_COUPON_FETCH_REQUEST';
export const SINGLE_COUPON_FETCH_REQUEST_SUCCESS = 'SINGLE_COUPON_FETCH_REQUEST_SUCCESS';
export const SINGLE_COUPON_FETCH_REQUEST_FAILURE = 'SINGLE_COUPON_FETCH_REQUEST_FAILURE';

export const DISCOUNT_CALCULATION_REQUEST = 'DISCOUNT_CALCULATION_REQUEST';
export const DISCOUNT_CALCULATION_REQUEST_SUCCESS = 'DISCOUNT_CALCULATION_REQUEST_SUCCESS';
export const DISCOUNT_CALCULATION_REQUEST_FAILURE = 'DISCOUNT_CALCULATION_REQUEST_FAILURE';

export const CLEAN_DISCOUNT_CALCULATION_PROPS = 'CLEAN_DISCOUNT_CALCULATION_PROPS';
